const getUserByEmail = async (db, email) => {
    const ref = await db.collection('users').doc(email).get()
    return ref.exists ? ref.data() : undefined
}

module.exports = getUserByEmail